export enum ECommonUrl {
  COMMON = 'common/api/v2',
  TENANT_RESIDENCIES = 'tenant-residencies',
  ALLOWED_ANIMAL_STATUS_UPDATE_ACTIONS = 'allowed-animal-status-update-actions',
}
